export const BUILD_VERSION = '1792630970';
